import React from "react";
import PropTypes from "prop-types";
import {Box, CircularProgress, Typography, useTheme} from "@mui/material";
import {primaryAccentAlpha} from "../../theme/colorTokens";
import {useCreditsBalance} from "../../context/CreditsBalanceContext";
import {
  ACTION_CREDIT_SUCCESS_NOTE,
  buildActionCreditEstimate,
  formatCompactCreditUsageSummary,
  isCreditBalanceResolved,
} from "../../helper/actionCreditEstimate";

export default function ActionCreditUsageBanner({
  actionId,
  selectedCount = 0,
  aiModelId,
  creditsPerUnit,
  testId = "action-credit-usage-banner",
}) {
  const theme = useTheme();
  const {balance, loading, refreshing, error} = useCreditsBalance();
  const balanceResolved = isCreditBalanceResolved({
    availableCredits: balance?.totalAvailable, loading, refreshing, error,
  });
  const estimate = buildActionCreditEstimate({
    actionId,
    selectedCount,
    aiModelId,
    creditsPerUnit,
    availableCredits: balanceResolved ? balance.totalAvailable : null,
  });
  if (!estimate.showEstimate) return null;
  const summary = formatCompactCreditUsageSummary(estimate);
  return (
    <Box
      data-testid={testId}
      sx={{width: "100%", borderRadius: "6px", bgcolor: primaryAccentAlpha(theme.palette.mode === "dark", 0.06), px: 1.25, py: 0.875}}
    >
      <Typography variant="caption" sx={{display: "block", fontWeight: 700}}>Estimated credit usage</Typography>
      {loading || refreshing ? <CircularProgress size={12} aria-label="Loading credits" /> : (
        <Typography variant="caption" color={estimate.hasShortfall ? "error.main" : "text.secondary"}>
          {error ? summary.willUseLabel : summary.statsLine}
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary" sx={{display: "block"}}>
        {actionId === 'find_and_verify_email'
          ? '1 credit per found address, verified or not. No charge for not-found or failed results.'
          : ACTION_CREDIT_SUCCESS_NOTE}
      </Typography>
    </Box>
  );
}

ActionCreditUsageBanner.propTypes = {
  actionId: PropTypes.string,
  selectedCount: PropTypes.number,
  aiModelId: PropTypes.string,
  creditsPerUnit: PropTypes.number,
  testId: PropTypes.string,
};
